import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useInsightsSummary(siteId: string, range: '24h' | '7d' | '30d') {
  return useQuery({
    queryKey: ['insights-summary', siteId, range],
    queryFn: () => api.sites.insightsSummary(siteId, range),
  });
}
